import { render, staticRenderFns } from "./CompletedTasks.vue?vue&type=template&id=26d27673"
import script from "./CompletedTasks.vue?vue&type=script&lang=js"
export * from "./CompletedTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports